import {
  CHANGE_PAYMENT_LOADING,
  CHANGE_PAYMENT_CASES,
  CHANGE_PAYMENT_DATE_INDEX,
  CHANGE_PAYMENT_DATES,
  TOGGLE_PAYMENT_VIEW_ALL
} from './actions'

export default function(state = {
  loading: false,
  cases: [],
  dateIndex: 0,
  dates: [],
  viewAll: false
}, action) {
  switch(action.type) {
    case CHANGE_PAYMENT_LOADING:
      return { ...state, loading: action.payload }
    case CHANGE_PAYMENT_CASES:
      return { ...state, cases: action.payload }
    case CHANGE_PAYMENT_DATE_INDEX:
      return { ...state, dateIndex: action.payload }
    case CHANGE_PAYMENT_DATES:
      return { ...state, dates: action.payload }
    case TOGGLE_PAYMENT_VIEW_ALL:

      return { ...state, viewAll: !state.viewAll }
    default:
      return state
  }
}
